import { Button } from '@client/components/ui/button';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface IntroViewProps {
  onGetStarted: () => void;
  onSkip: () => void;
}

export function IntroView({ onGetStarted, onSkip }: IntroViewProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-primary text-xs font-semibold uppercase tracking-wide">
            Personalize
          </span>
          <span className="bg-primary-200 rounded-full px-2 py-1 text-xs text-black">
            3 questions
          </span>
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Refine your results</h3>
        <p className="text-sm text-gray-600">
          Answer a few quick questions to filter these options and see only the policies that match
          your preferences.
        </p>
      </div>
      <div className="flex flex-col items-center gap-2">
        <Button
          onClick={onGetStarted}
          className="shadow-primary-lg gap-2 rounded-full"
          size="lg"
        >
          Get started
          <ArrowRight className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          type="button"
          onClick={onSkip}
          className="text-sm text-gray-500 transition-colors hover:text-gray-700"
        >
          Skip for now
        </Button>
      </div>
    </motion.div>
  );
}
